import React from 'react';
import { T } from '../../theme/tokens';

export function ProgressBar({ done, total, color }) {
  return (
    <div
      style={{
        height: 4,
        borderRadius: 0,
        background: T.borderLight,
        overflow: "hidden",
        marginBottom: 28,
      }}
    >
      <div
        style={{
          height: "100%",
          width: `${(done / total) * 100}%`,
          background: color || T.accent,
          transition: "width .3s ease",
        }}
      />
    </div>
  );
}
